// Pure helpers for the category-metafield groups (kept out of the components so Jest can reach them).

// A list shows up to two values, then "N values"; a single value is itself; nothing is "—".
export function summarizeValues(value) {
  if (Array.isArray(value)) {
    if (!value.length) return '—';
    return value.length <= 2 ? value.join(', ') : `${value.length} values`;
  }
  return value == null || value === '' ? '—' : String(value);
}

export const isEmptyValue = (v) => v == null || v === '' || (Array.isArray(v) && v.length === 0);

// "Sporting Goods > Athletics > Soccer > Soccer Shoes" -> "Soccer Shoes".
export const leafName = (path) => (path ? path.split(' > ').pop() : '');

// The ordered facet ids for the two groups. Facets that carry an entry but sit in neither group are appended to the
// Soccer Post group so a value is never hidden. Falls back to every effective facet when the payload has no groups.
export function groupIds(d) {
  const eff = (d.effective && d.effective.facets) || {};
  const g = d.facet_groups;
  if (!g) return { shopify: [], soccer_meta: Object.keys(eff).filter((k) => k !== 'category') };
  const seen = new Set([...(g.shopify || []), ...(g.soccer_meta || [])]);
  const extra = Object.keys(eff).filter((k) => k !== 'category' && !seen.has(k));
  return { shopify: g.shopify || [], soccer_meta: [...(g.soccer_meta || []), ...extra] };
}

// The shopify.<handle> / soccer_meta.<id> key shown under a label.
export function keyText(id, meta) {
  if (meta && meta.key) return meta.key;   // the server names it (shopify.color-pattern for the legacy colour facet)
  const source = meta && meta.source;
  if (source === 'taxonomy' || String(id).startsWith('shopify.')) return String(id).startsWith('shopify.') ? id : `shopify.${id}`;
  return `soccer_meta.${id}`;
}

// Review-table chips: the standard facets of a row that carry a value (or are required and empty), as {text, tone}.
export function reviewChips(stdFacets) {
  return (stdFacets || []).map((f) => {
    const empty = isEmptyValue(f.value);
    const imageOnly = !empty && (f.sources || []).length === 1 && f.sources[0] === 'image';
    return {
      key: f.id,
      text: `${f.label || f.id}: ${empty ? '—' : summarizeValues(f.value)}${imageOnly ? ' (image only)' : ''}`,
      warn: imageOnly || (empty && !!f.required),
    };
  });
}
